import { useSearchParams } from 'react-router-dom';
import { useGetPlanetaryPositionFromMoonQuery } from '@/store/api/planetaryPositionApi';
import Loader from '@/components/Loader';

import { formatDegree } from '@/utils/degreeUtils';

export default function PlanetaryPosition() {
  const [params] = useSearchParams();
  const userId = params.get('userId');

  const { data, isLoading, isError } = useGetPlanetaryPositionFromMoonQuery(userId, {
    skip: !userId,
  });

  if (isError) {
    return <p className="p-6 text-center text-red-500">Failed to load Planetary Position data</p>;
  }

  return (
    <div className="">
      <h3 className="font-32 font-semibold font-spectral mb-6 bg-clip-text text-transparent bg-gradient-to-r from-[#082261] to-[#34065c] text-center heading-uppercase">
        PlANETARY POSITION FROM MOON / RASHI ({data?.planetaryTransitsFromMoon?.[0]?.sign}) - NATAL
        CHART
      </h3>

      <div className="overflow-x-auto">
        {isLoading ? (
          <Loader />
        ) : (
          <table className="min-w-full mt-4 border-collapse border border-[#2DAAFD] font-18 whitespace-nowrap">
            <thead className="bg-[#001B6B] text-white font-spectral uppercase">
              <tr>
                <th className="border px-3 py-2 min-w-[153px]">Planet / Asc</th>
                <th className="border px-3 py-2 min-w-[185px]">Sign</th>
                <th className="border px-3 py-2">Degree</th>
                <th className="border px-3 py-2">Awastha</th>
                <th className="border px-3 py-2">Sign Lord</th>
                <th className="border px-3 py-2">Nakshatra</th>
                <th className="border px-3 py-2">
                  Nakshatra <br /> Pada
                </th>
                <th className="border px-3 py-2">Nakshatra Lord</th>
                <th className="border px-3 py-2">House</th>
              </tr>
            </thead>

            <tbody>
              {(data?.planetaryTransitsFromMoon ?? []).map((row: any, i: number) => (
                <tr
                  key={row.id ?? i}
                  className={
                    i % 2 === 0
                      ? 'bg-white text-black'
                      : 'text-black bg-[linear-gradient(to_right,#B7E2FF,#2DAAFD)]'
                  }
                >
                  <td className="border border-black px-3 py-2">{row.name ?? '-'}</td>

                  <td className="border border-black px-3 py-2">{row.sign ?? '-'}</td>

                  <td className="border border-black px-3 py-2 text-center">
                    {formatDegree(row.sign, row.degree)}
                  </td>

                  <td className="border border-black px-3 py-2 text-center">
                    {row.planetAwastha ?? '-'}
                  </td>

                  <td className="border border-black px-3 py-2 text-center">
                    {row.signLord ?? '-'}
                  </td>

                  <td className="border border-black px-3 py-2 text-center">
                    {row.nakshatra ?? '-'}
                  </td>

                  <td className="border border-black px-3 py-2 text-center">
                    {row.nakshatraPada ?? '-'}
                  </td>

                  <td className="border border-black px-3 py-2 text-center">
                    {row.nakshatraLord ?? '-'}
                  </td>

                  <td className="border border-black px-3 py-2 text-center">{row.house ?? '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
